/**
 * Creates a local storage token by combining the prefix and the given token.
 *
 * @param {string} token - The token to be prefixed.
 * @returns {string} The combined local storage token.
 */
const createLocalStoreToken = (token) => {
  return `${LOCAL_STORAGE_KEY_PREFIX}${token}`
}

export const LOCAL_STORAGE_KEY_PREFIX = 'amg-platform:'

export const LOCAL_STORAGE_KEYS = {
  PERSIST_STATE: createLocalStoreToken('persist-state')
}
